<template>
  <div class="fldy-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="操作时间">
              <el-date-picker
                v-model="searchForm.opertime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                >
                  <el-table-column
                    label="月份"
                    width="60"
                    align="center"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.month }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="周次"
                    width="60"
                    align="center"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.week }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.ordernum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="时间"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="发现工序"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.testProcess }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="发现人"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.fxrname }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="责任部门"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.dept }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="不良类别"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.bad }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="责任工序"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.process }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="直接责任人"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.dutyName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="乐捐"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{ scope.row.punish }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="返修负责人"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.principalName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="返工成本"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.cost }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="计划完成时间"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.planned }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="不良现象描述"
                    min-width="240"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.descc }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="处理措施"
                    width="240"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.measures }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="负责人确认时间"
                    width="170"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.contime==null||scope.row.contime==''||scope.row.contime==undefined" size="mini" type="danger">未确认</el-tag>
                      <span v-if="scope.row.contime!==null&&scope.row.contime!==''&&scope.row.contime!==undefined">{{ scope.row.contime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="100"
                    fixed="right"
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button size="mini" type="primary" :loading="eidtLoading" :disabled="scope.row.contime==null||scope.row.contime==''||scope.row.contime==undefined?false:true" @click="affirmReworkOrder(scope.row)">确认交期</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </el-col>
            </el-row>
          </div>
          <el-dialog
            :title="reworkTitle"
            :visible.sync="reworkdialogVisible"
            width="800px"
            top="10vh"
            :destroy-on-close="true"
            :lock-scroll="true"
            :append-to-body="true"
          >
            <div v-loading="reworkEditFormLoading">
              <el-form ref="reworkEditForm" size="small" :model="reworkEditForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="reworkRules">
                <el-form-item label="选择时间" prop="time">
                  <el-date-picker
                    v-model="reworkEditForm.time"
                    :disabled="true"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    type="date"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="责任工序" prop="process">
                  <el-select v-model="reworkEditForm.process" placeholder="请选择" :disabled="true">
                    <el-option
                      v-for="item in reworkProcessData"
                      :key="item.rpid"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="返工成本" prop="cost">
                  <el-input-number v-model="reworkEditForm.cost" :min="0" :precision="2" :disabled="true"></el-input-number>
                </el-form-item>
                <el-form-item label="人工成本" prop="laborCost">
                  <el-input-number v-model="reworkEditForm.laborCost" :min="0" :precision="2" :disabled="true"></el-input-number>
                </el-form-item>
                <el-form-item label="材料成本" prop="stuffCost">
                  <el-input-number v-model="reworkEditForm.stuffCost" :min="0" :precision="2" :disabled="true"></el-input-number>
                </el-form-item>
                <el-form-item label="乐捐" prop="punish">
                  <el-input-number v-model="reworkEditForm.punish" :min="0" :precision="2" :disabled="true"></el-input-number>
                </el-form-item>
                <el-form-item label="直接责任人" prop="resid">
                  <UserSelect :key="keyNum1" v-model="reworkEditForm.resid" :set="reworkEditForm.oldresid" :userid="user.dUserid" :disabled="true"></UserSelect>
                </el-form-item>
                <el-form-item label="返修负责人" prop="principalid">
                  <UserSelect :key="keyNum2" v-model="reworkEditForm.principalid" :set="reworkEditForm.oldid" :userid="user.dUserid" :disabled="true"></UserSelect>
                </el-form-item>
                <el-form-item label="计划完成" prop="planned">
                  <el-date-picker
                    v-model="reworkEditForm.planned"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    type="date"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item style="text-align: right">
                  <el-button :loading="reworkEditLoading" type="primary" @click="SubReworkForm('reworkEditForm')">立即提交</el-button>
                  <el-button @click="reworkdialogVisible=false">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getUser } from '@/utils/auth'
import {
  getMyReworkOrderList,
  getReworkProcessAll,
  affirmReworkOrder,
  exportReworkOrderList,
  addReworkOrder
} from '@/api/erp'
import UserSelect from '@/components/UserSelect/index'

export default {
  name: 'Fgd',
  components: { UserSelect },
  data() {
    return {
      keyNum1: null,
      keyNum2: null,
      eidtLoading: false,
      loading: false,
      exportLoading: false,
      tableData: [],
      reworkProcessData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        opertime: [],
        search: null
      },
      reworkdialogVisible: false,
      reworkEditFormLoading: false,
      reworkEditLoading: false,
      reworkTitle: '确认交期',
      reworkEditForm: {
        orderid: '',
        roid: null,
        qid: null,
        time: null,
        process: null,
        cost: null,
        planned: null,
        principalid: null,
        oldid: null,
        resid: null,
        oldresid: null,
        punish: null,
        laborCost: null,
        stuffCost: null
      },
      reworkRules: {
        planned: [{ required: true, message: '请选择日期', trigger: 'change' }]
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getReworkProcessAll()
    this.getData()
  },
  methods: {
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        let starttime = ''
        let endtime = ''
        if (this.searchForm.opertime !== null && this.searchForm.opertime !== undefined) {
          if (this.searchForm.opertime.length === 2) {
            starttime = this.searchForm.opertime[0]
            endtime = this.searchForm.opertime[1]
          }
        }
        const data = {
          content: this.searchForm.search,
          starttime: starttime,
          endtime: endtime,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          role: this.user.role
        }
        this.$message({
          message: '数据正在导出，请稍候'
        })
        exportReworkOrderList(data).then(response => {
          this.exportLoading = false
          const _this = this
          const xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              const blob = this.response
              const a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    affirmReworkOrder(row) {
      this.reworkEditForm.roid = row.roid
      this.reworkEditForm.qid = row.qid
      this.reworkEditForm.time = row.time
      this.reworkEditForm.process = row.process
      this.reworkEditForm.cost = row.cost
      this.reworkEditForm.planned = row.planned
      this.reworkEditForm.principalid = row.principalid
      this.reworkEditForm.oldid = row.principalid
      this.reworkEditForm.resid = row.resid
      this.reworkEditForm.oldresid = row.resid
      this.reworkEditForm.punish = row.punish
      this.reworkEditForm.laborCost = row.laborCost
      this.reworkEditForm.stuffCost = row.stuffCost
      this.reworkdialogVisible = true
    },
    SubReworkForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.reworkEditLoading = true
          const data = {
            roid: this.reworkEditForm.roid,
            planned: this.reworkEditForm.planned
          }
          affirmReworkOrder(data).then(response => {
            this.reworkEditLoading = false
            this.reworkdialogVisible = false
            this.eidtLoading = false
            this.getData()
            this.$message.success('提交成功')
          }).catch(() => {
            this.reworkEditLoading = false
            this.$message.error('提交失败')
          })
        }
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    getData() {
      this.loading = true
      let starttime = ''
      let endtime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime !== undefined) {
        if (this.searchForm.opertime.length === 2) {
          starttime = this.searchForm.opertime[0]
          endtime = this.searchForm.opertime[1]
        }
      }
      const data = {
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      getMyReworkOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    getReworkProcessAll() {
      getReworkProcessAll().then(response => {
        this.reworkProcessData = response.data
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .fldy-container {
    .tcf-row{
      .card{
        .card-body{
          .card-title{
            .search-mode{
              width: 300px;
              position: relative;
              float: right;
              margin-top: -10px;
              .search-input{
                background-color: #F2F6FC;
                border:0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;
                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }
                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }
              .search-btn{
                position: absolute;
                right: 0;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
            }
          }
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .client-sex{
              width: 16px!important;
              height: 16px!important;
              vertical-align: -4px!important;
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
</style>
